/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_RulesInputs */

const en_pb_rules = /** @type {(inputs: Pb_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules`)
};

const id_pb_rules = /** @type {(inputs: Pb_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan`)
};

/**
* | output |
* | --- |
* | "Rules" |
*
* @param {Pb_RulesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_rules = /** @type {((inputs?: Pb_RulesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_RulesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_rules(inputs)
	return en_pb_rules(inputs)
});